import { Link } from 'react-router-dom';
import { CheckCircle, Calendar, Mail, ArrowRight, Phone, Clock } from 'lucide-react';
import { Button } from '../components/ui/button';

export default function ThankYou() {
  return (
    <div className="min-h-screen bg-[#F9FAFB]" data-testid="thank-you-page">
      {/* Success Header */}
      <div className="bg-[#002FA7] py-16 md:py-24 px-6 text-center">
        <div className="max-w-2xl mx-auto">
          <div className="w-20 h-20 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-6">
            <CheckCircle className="w-10 h-10 text-white" />
          </div>
          <h1 className="text-3xl md:text-5xl font-black text-white mb-4" data-testid="thank-you-title">
            Payment Confirmed!
          </h1>
          <p className="text-white/80 text-lg">
            Thank you for choosing RikirTutor. Here's what happens next.
          </p>
        </div>
      </div>

      {/* Next Steps */}
      <div className="max-w-3xl mx-auto px-6 py-12 md:py-16">
        <h2 className="text-2xl font-bold text-[#0A0A0A] text-center mb-10">Your Next Steps</h2>

        <div className="space-y-6">
          {/* Step 1 */}
          <div className="bg-white border border-[#E5E7EB] rounded-sm p-6 flex gap-5" data-testid="step-1">
            <div className="w-12 h-12 bg-[#002FA7] text-white rounded-full flex items-center justify-center flex-shrink-0 font-black text-lg">
              1
            </div>
            <div>
              <h3 className="font-bold text-[#0A0A0A] text-lg mb-2">Create Your Account</h3>
              <p className="text-[#4B5563] mb-4">
                If you haven't already, create a free account so we can set up your dashboard and schedule your sessions.
              </p>
              <Link to="/register">
                <Button className="bg-[#002FA7] hover:bg-[#001B63] text-white font-bold rounded-sm" data-testid="register-btn">
                  Create Account
                  <ArrowRight className="w-4 h-4 ml-2" />
                </Button>
              </Link>
            </div>
          </div>

          {/* Step 2 */}
          <div className="bg-white border border-[#E5E7EB] rounded-sm p-6 flex gap-5" data-testid="step-2">
            <div className="w-12 h-12 bg-[#002FA7] text-white rounded-full flex items-center justify-center flex-shrink-0 font-black text-lg">
              2
            </div>
            <div>
              <h3 className="font-bold text-[#0A0A0A] text-lg mb-2">Schedule Your Session</h3>
              <p className="text-[#4B5563] mb-3">
                Log into your dashboard and pick a date, time, and subject for your tutoring session. You'll receive a confirmation email with your meeting link.
              </p>
              <div className="flex items-center gap-2 text-sm text-[#4B5563]">
                <Clock className="w-4 h-4 text-[#002FA7]" />
                <span>Sessions available Mon-Sat, 8 AM - 10 PM</span>
              </div>
            </div>
          </div>

          {/* Step 3 */}
          <div className="bg-white border border-[#E5E7EB] rounded-sm p-6 flex gap-5" data-testid="step-3">
            <div className="w-12 h-12 bg-[#002FA7] text-white rounded-full flex items-center justify-center flex-shrink-0 font-black text-lg">
              3
            </div>
            <div>
              <h3 className="font-bold text-[#0A0A0A] text-lg mb-2">Join Your Session</h3>
              <p className="text-[#4B5563] mb-3">
                You'll get an email reminder 24 hours before your session. Click the meeting link at your scheduled time and you're in!
              </p>
              <div className="flex items-center gap-2 text-sm text-[#4B5563]">
                <Calendar className="w-4 h-4 text-[#002FA7]" />
                <span>24-hour email reminders included</span>
              </div>
            </div>
          </div>
        </div>

        {/* Contact Info */}
        <div className="mt-10 bg-[#0A0A0A] rounded-sm p-8 text-center" data-testid="contact-info">
          <h3 className="text-white font-bold text-lg mb-2">Need Help?</h3>
          <p className="text-white/60 mb-6">Our team is here to make sure you get the most out of your sessions.</p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-6">
            <a href="mailto:acerikir1@gmail.com" className="flex items-center gap-2 text-white hover:text-[#FFC107] transition-colors">
              <Mail className="w-5 h-5" />
              <span className="font-medium">acerikir1@gmail.com</span>
            </a>
            <Link to="/contact" className="flex items-center gap-2 text-white hover:text-[#FFC107] transition-colors">
              <Phone className="w-5 h-5" />
              <span className="font-medium">Contact Page</span>
            </Link>
          </div>
        </div>

        {/* Guarantee Reminder */}
        <div className="mt-8 text-center">
          <p className="text-sm text-[#059669] font-bold flex items-center justify-center gap-2">
            <CheckCircle className="w-4 h-4" />
            Remember: If you don't improve, your next session is free.
          </p>
        </div>

        {/* CTA */}
        <div className="mt-10 text-center">
          <Link to="/dashboard">
            <Button className="bg-[#002FA7] hover:bg-[#001B63] text-white font-bold px-8 py-6 rounded-sm text-base" data-testid="go-dashboard-btn">
              Go to Dashboard
              <ArrowRight className="w-5 h-5 ml-2" />
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
